module.exports = __webpack_public_path__ + "static/media/service_default.f0d88b53.png";